import React from 'react';
import {Playlist} from "../../components/playlist/Playlist";

export const PlaylistPage: React.FC = () => {

    return (
        <div>
            <Playlist/>
        </div>
    );
};
